/* SmartReserve theme.js, gemeenschappelijke interacties */
(function() {
  'use strict';

  // ===== Mobile drawer =====
  const drawer = document.querySelector('[data-mobile-drawer]');
  const drawerToggle = document.querySelector('[data-drawer-toggle]');
  const drawerClose = document.querySelector('[data-drawer-close]');
  const overlay = document.querySelector('[data-overlay]');
  function openDrawer() { drawer?.classList.add('is-open'); overlay?.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer?.classList.remove('is-open'); overlay?.classList.remove('is-open'); document.body.style.overflow = ''; }
  drawerToggle?.addEventListener('click', openDrawer);
  drawerClose?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);

  // ===== Cart drawer =====
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartTrigger = document.querySelector('[data-cart-trigger]');
  const cartClose = document.querySelector('[data-cart-close]');
  function openCart() { cartDrawer?.classList.add('is-open'); overlay?.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { cartDrawer?.classList.remove('is-open'); overlay?.classList.remove('is-open'); document.body.style.overflow = ''; }
  cartTrigger?.addEventListener('click', function(e) { e.preventDefault(); openCart(); fetchCart(); });
  cartClose?.addEventListener('click', closeCart);

  // ===== Cart API =====
  // okt 2026: de gratis P1 (UNLISTED, €0) mag alleen mee met een Anker-batterij, maximaal 1 per bestelling.
  // Staat hij zonder batterij in de mand (bv. via een directe link), of vaker dan 1x, dan zet de winkelmand dat recht.
  // Let op: een directe checkout-link (/cart/<variant>:1) slaat de theme over; daarvoor is de Flow-controle (README).
  const FREE_P1_VARIANT = 54422591996251;
  const ANKER_BATTERY_PRODUCT = 10779698561371;
  function guardFreeP1(cart) {
    const p1 = cart.items.filter(i => i.variant_id === FREE_P1_VARIANT);
    if (!p1.length) return null;
    const hasBattery = cart.items.some(i => i.product_id === ANKER_BATTERY_PRODUCT);
    const allowed = hasBattery ? 1 : 0;
    const total = p1.reduce((n, i) => n + i.quantity, 0);
    if (total <= allowed) return null;
    const updates = {};
    p1.forEach((i, idx) => { updates[i.key] = (idx === 0 ? allowed : 0); });
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(r => r.json());
  }
  function fetchCart() {
    return fetch('/cart.js').then(r => r.json())
      .then(cart => { const fix = guardFreeP1(cart); return fix ? fix : cart; })
      .then(cart => {
      renderCart(cart);
      updateCartCount(cart.item_count);
      // 30-9: raket (winkelmandkeuzes contract/afhalen) luistert hierop
      document.dispatchEvent(new CustomEvent('sr:cart', { detail: cart }));
      return cart;
    });
  }
  window.SR = window.SR || {};
  window.SR.fetchCart = fetchCart;
  function updateCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
  }
  function renderCart(cart) {
    const items = document.querySelector('[data-cart-items]');
    const total = document.querySelector('[data-cart-total]');
    if (!items) return;
    if (cart.item_count === 0) {
      items.innerHTML = '<p style="text-align:center;color:var(--sr-text-medium);padding:48px 0;">Je winkelmand is leeg.</p>';
      if (total) total.textContent = '€0,00';
      return;
    }
    items.innerHTML = cart.items.map(item => `
      <div class="cart-drawer__item">
        <img src="${item.image}" alt="${item.title}">
        <div style="flex:1;">
          <div style="font-weight:600;">${item.product_title}</div>
          <div style="font-size:13px;color:var(--sr-text-medium);">${item.variant_title || ''}</div>
          <div style="display:flex;align-items:center;gap:8px;margin-top:8px;">
            <button data-cart-qty="${item.key}" data-qty="${item.quantity - 1}">−</button>
            <span class="mono">${item.quantity}</span>
            <button data-cart-qty="${item.key}" data-qty="${item.quantity + 1}">+</button>
            <span style="margin-left:auto;" class="mono">€${(item.line_price/100).toFixed(2).replace('.', ',')}</span>
          </div>
        </div>
      </div>
    `).join('');
    if (total) total.textContent = '€' + (cart.total_price/100).toFixed(2).replace('.', ',');
  }
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-cart-qty]');
    if (btn) {
      const key = btn.dataset.cartQty;
      const qty = parseInt(btn.dataset.qty, 10);
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
        .then(() => fetchCart());
    }
  });

  // ===== Add-to-cart form (any) =====
  // 24-9: extra's met een eigen product (CT-meter €80, installatie €149) gaan als aparte regel
  // mee naar de winkelmand, zodat ze bij het afrekenen ook echt betaald worden.
  const ADDONS = [
    { selector: 'input[name="properties[Slimme CT Meter]"]:checked', property: 'properties[Slimme CT Meter]', variant: 54179167535451 },
    { selector: 'input[name="properties[Installatie]"][value*="€149"]:checked', property: 'properties[Installatie]', variant: 54179167928667 },
    // okt 2026: Anker SOLIX accessoires (alleen op de Solarbank Max AC-pagina aanwezig). Variant-ids ingevuld 20-10.
    // P1: de UNLISTED €0-variant 'gratis bij batterij'. Los bestellen gaat via het ACTIEVE product van €49.
    { selector: 'input[name="properties[Anker P1 Meter]"]:checked', property: 'properties[Anker P1 Meter]', variant: 54422591996251 },
    { selector: 'input[name="properties[Anker Smart Meter]"][value^="1-fase"]:checked', property: 'properties[Anker Smart Meter]', variant: 54422596649307 },
    { selector: 'input[name="properties[Anker Smart Meter]"][value^="3-fase"]:checked', property: 'properties[Anker Smart Meter]', variant: 54422599631195 },
    { selector: 'input[name="properties[Anker Smart Plug]"]:checked', property: 'properties[Anker Smart Plug]', variant: 54422604054875, qtySelector: '[data-sr-qty-smartplug]', maxQty: 4 },
    { selector: 'input[name="properties[Anker Backup Auto-Switch]"]:checked', property: 'properties[Anker Backup Auto-Switch]', variant: 54422607659355 },
    { selector: 'input[name="properties[Anker Montagebasis]"]:checked', property: 'properties[Anker Montagebasis]', variant: 54422608544091 },
    { selector: 'input[name="properties[Anker AC-kabel Schuko 15 m]"]:checked', property: 'properties[Anker AC-kabel Schuko 15 m]', variant: 54422615064923 }
  ];
  // Aantal voor een add-on met qtySelector (bijv. Smart Plug 1-4); zonder qtySelector altijd 1.
  function addonQty(form, a) {
    if (!a.qtySelector) return 1;
    const el = form.querySelector(a.qtySelector);
    const q = parseInt((el || {}).value || '1', 10) || 1;
    return Math.min(Math.max(q, 1), a.maxQty || 1);
  }
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const formData = new FormData(form);
    const addons = ADDONS.filter(a => form.querySelector(a.selector));
    let request;
    if (addons.length) {
      const properties = {};
      formData.forEach((value, key) => {
        const m = key.match(/^properties\[(.+)\]$/);
        if (m && !addons.some(a => a.property === key)) properties[m[1]] = value;
      });
      const items = [{ id: parseInt(formData.get('id'), 10), quantity: parseInt(formData.get('quantity') || '1', 10), properties: properties }];
      addons.forEach(a => items.push({ id: a.variant, quantity: addonQty(form, a) }));
      request = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) });
    } else {
      request = fetch('/cart/add.js', { method: 'POST', body: formData });
    }
    request
      .then(r => r.json())
      .then(() => fetchCart())
      .then(() => openCart());
  });

  // Initialize cart count
  fetchCart();

  // ===== Scroll reveal =====
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('in-view'); io.unobserve(entry.target); } });
    }, { threshold: 0.15 });
    reveals.forEach(el => io.observe(el));
  }

  // ===== Product configurator =====
  document.querySelectorAll('[data-configurator]').forEach(initConfigurator);
  function initConfigurator(form) {
    const totalEl = form.querySelector('[data-total-amount]');
    const stickyPriceEl = document.querySelector('[data-sticky-price]');
    const variantsData = form.dataset.variants ? JSON.parse(form.dataset.variants) : null;
    function getVariantPrice() {
      const checked = form.querySelector('[data-variant-input]:checked');
      if (!checked || !variantsData) return 0;
      const v = variantsData.find(x => String(x.id) === String(checked.value));
      // okt 2026: meerdere torens van dezelfde maat gaan als aantal mee (stapelcomponent zet quantity)
      const q = parseInt((form.querySelector('input[name="quantity"]') || {}).value || '1', 10) || 1;
      return v ? v.price * q : 0;
    }
    function getExtras() {
      let extra = 0;
      form.querySelectorAll('[data-extra-price]:checked').forEach(input => {
        // okt 2026: data-extra-qty wijst naar een aantal-keuze (Smart Plug 1-4); anders telt de extra 1 keer.
        const qEl = input.dataset.extraQty ? form.querySelector(input.dataset.extraQty) : null;
        const q = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
        extra += parseInt(input.dataset.extraPrice, 10) * 100 * q;
      });
      const installRadio = form.querySelector('input[name="properties[Installatie]"]:checked');
      if (installRadio && installRadio.value.includes('€149')) extra += 14900;
      return extra;
    }
    function fmt(cents) { return '€' + (cents/100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function update() {
      const total = getVariantPrice() + getExtras();
      if (totalEl) totalEl.textContent = fmt(total);
      if (stickyPriceEl) stickyPriceEl.textContent = fmt(total);
      form.querySelectorAll('.sr-variant-card').forEach(card => {
        const input = card.querySelector('[data-variant-input]');
        card.classList.toggle('is-active', input && input.checked);
      });
      form.querySelectorAll('.sr-option-card').forEach(card => {
        const input = card.querySelector('input[type="radio"]');
        card.classList.toggle('is-active', input && input.checked);
      });
    }
    form.addEventListener('change', update);
    update();
  }

  // ===== Bespaarcalculator =====
  // Eerlijke bandbreedte i.p.v. één rooskleurig getal. Herzien sep 2026: het losse 'handel'-blok
  // (in- en verkopen op de markt over de volle capaciteit) is vervangen door een tariefshift voor
  // EIGEN verbruik: bij een dynamisch contract laden op de goedkope uren en die stroom zelf gebruiken
  // op de dure uren. Geen terugleveren voor winst, geen onbalanshandel.
  // Bronnen voor de parameters:
  //  - Inkoopprijs stroom: CBS 'Gemiddelde energietarieven voor consumenten' (juni 2026: €0,263/kWh incl. heffingen) → wij rekenen €0,26 tot €0,27.
  //  - Terugleververgoeding: gangbare vergoedingen NL-leveranciers 2026 (€0,04 tot €0,07/kWh).
  //  - Tariefshift dynamisch: EPEX Spot day-ahead uurprijzen; all-in verschil (incl. belasting en btw) tussen de
  //    goedkoopste nachturen en de dure avonduren €0,13 tot €0,20/kWh bruto, ≈ €0,12 tot €0,18 na laadverliezen,
  //    op 300 tot 365 dagen per jaar.
  //  - Verbruik buiten de zonne-uren: 60% van het dagverbruik (ochtend, avond, nacht). Alleen dát deel kan de
  //    batterij uit opslag leveren. Wat de zon al gevuld heeft, laden we niet nog eens uit het net: geen dubbeltelling.
  //  - Opbrengst per paneel: Milieu Centraal (850 tot 950 kWh/kWp geeft ±400 kWh voor een modern 430 tot 450 Wp paneel).
  //  - CO2-factor: 0,3 kg/kWh, bewust conservatiever dan Milieu Centraal (0,36).
  //  - Rendement/degradatie: LiFePO4-fabrieksspecificaties (90% round-trip, 90% capaciteit gem. over 10 jaar).
  //  Vast en variabel tarief: alleen de zonneshift, want binnen de dag is er geen tariefverschil.
  //  Advies loopt tot 54 kWh (2× en 3× Halo 18) voor grootverbruikers; bij een dynamisch contract telt naast het
  //  zonoverschot ook het eigen verbruik buiten de zonne-uren mee (factor 0,4 × dagverbruik als ondergrens).
  document.querySelectorAll('[data-calculator]').forEach(initCalculator);
  function initCalculator(root) {
    const TARIFFS = {
      vast:      { buy: 0.27, sell: 0.06, shiftLow: 0,    shiftHigh: 0    },
      variabel:  { buy: 0.26, sell: 0.05, shiftLow: 0,    shiftHigh: 0    },
      dynamisch: { buy: 0.26, sell: 0.04, shiftLow: 0.13, shiftHigh: 0.20 }
    };
    const KWH_PER_PANEL = 400;     // kWh opwek per paneel per jaar (Milieu Centraal: 850 tot 950 kWh/kWp)
    const CO2_FACTOR = 0.3;        // kg CO2 per kWh (conservatiever dan Milieu Centraal 0,36)
    const EFFICIENCY = 0.90;       // round-trip rendement
    const USABLE = 0.90;           // bruikbaar deel van de capaciteit
    const UTIL_LOW = 0.65;         // benutting zonoverschot, laag scenario (winter/bewolkte dagen)
    const UTIL_HIGH = 0.85;        // benutting zonoverschot, hoog scenario
    const NON_SOLAR_SHARE = 0.60;  // deel van het dagverbruik buiten de zonne-uren (ochtend, avond, nacht)
    const SHIFT_DAYS_LOW = 300;    // dagen/jaar met zinvol verschil tussen goedkope en dure uren, laag scenario
    const SHIFT_DAYS_HIGH = 365;   // hoog scenario
    const YEARS = 10;              // horizon = garantieperiode
    const DEGRADATION = 0.90;      // gemiddelde capaciteit over 10 jaar
    const inputs = {
      panels: root.querySelector('[data-input="panels"]'),
      daily: root.querySelector('[data-input="daily"]'),
      contract: root.querySelector('[data-input="contract"]'),
      postcode: root.querySelector('[data-input="postcode"]')
    };
    const out = {
      panels: root.querySelector('[data-display="panels"]'),
      daily: root.querySelector('[data-display="daily"]'),
      kwhYear: root.querySelector('[data-display="kwh-year"]'),
      yearly: root.querySelector('[data-display="yearly"]'),
      payback: root.querySelector('[data-display="payback"]'),
      lifetime: root.querySelector('[data-display="lifetime"]'),
      co2: root.querySelector('[data-display="co2"]'),
      setup: root.querySelector('[data-display="setup"]'),
      setupLink: root.querySelector('[data-display="setup-link"]')
    };
    function fmtEur(n) { return '€' + Math.round(n).toLocaleString('nl-NL'); }
    function fmtRange(a, b) { return fmtEur(a) + ' tot ' + fmtEur(b); }
    function fmtYears(n) { return n.toFixed(1).replace('.', ','); }
    function calc() {
      if (!inputs.panels) return;
      const panels = parseInt(inputs.panels.value, 10);
      const daily = parseFloat(inputs.daily.value);
      const tariff = TARIFFS[inputs.contract.value] || TARIFFS.dynamisch;
      const kwhYear = panels * KWH_PER_PANEL;
      const dailyOpwek = kwhYear / 365;
      const dailyOverschot = Math.max(0, dailyOpwek - daily * 0.3);
      const nonSolarUse = daily * NON_SOLAR_SHARE;
      // Aanbevolen capaciteit: wat je buiten de zonne-uren zelf kunt gebruiken én overdag kunt vullen.
      // Bij een dynamisch contract telt ook het verbruik mee: de batterij vult zich dan ook op goedkope uren.
      const dynFloor = (inputs.contract.value === 'dynamisch') ? daily * 0.4 : 0;
      const recCap = Math.min(Math.max(Math.max(dailyOverschot, dynFloor), 3), nonSolarUse);
      // HYXI Halo: stapelbaar 6 tot 18 kWh per set (2 tot 6 modules van 3 kWh), tot 3 sets = 54 kWh.
      let setup, setupPrice, setupCap;
      if (recCap < 7.5)       { setup = 'Halo 6 met 6 kWh';   setupPrice = 1399;  setupCap = 6; }
      else if (recCap < 10.5) { setup = 'Halo 9 met 9 kWh';   setupPrice = 1939;  setupCap = 9; }
      else if (recCap < 13.5) { setup = 'Halo 12 met 12 kWh'; setupPrice = 2550;  setupCap = 12; }
      else if (recCap < 16.5) { setup = 'Halo 15 met 15 kWh'; setupPrice = 3170;  setupCap = 15; }
      else if (recCap < 27)   { setup = 'Halo 18 met 18 kWh'; setupPrice = 3770;  setupCap = 18; }
      else if (recCap < 45)   { setup = '2× Halo 18 met 36 kWh totaal'; setupPrice = 7540;  setupCap = 36; }
      else                    { setup = '3× Halo 18 met 54 kWh totaal'; setupPrice = 11310; setupCap = 54; }
      const usableCap = setupCap * USABLE;
      const shiftBase = Math.min(dailyOverschot, usableCap);
      // Wat de batterij per dag maximaal aan eigen verbruik buiten de zonne-uren kan leveren.
      const dailyNeed = Math.min(usableCap, nonSolarUse);
      function scenario(util, shiftSpread, shiftDays) {
        const solarShift = shiftBase * util;                                   // kWh/dag gevuld door de zon
        const selfBenefit = solarShift * 365 * (tariff.buy - tariff.sell) * EFFICIENCY;
        // Het deel van je eigen verbruik dat de zon niet gevuld heeft, laad je bij een dynamisch contract op de
        // goedkope uren en gebruik je zelf op de dure uren. Geen terugleveren, geen handel.
        const gridShift = Math.max(0, dailyNeed - solarShift);                // kWh/dag uit goedkope uren
        const tariffBenefit = shiftSpread > 0 ? gridShift * shiftDays * shiftSpread * EFFICIENCY : 0;
        return selfBenefit + tariffBenefit;
      }
      const yearlyLow = Math.max(0, scenario(UTIL_LOW, tariff.shiftLow, SHIFT_DAYS_LOW));
      const yearlyHigh = Math.max(0, scenario(UTIL_HIGH, tariff.shiftHigh, SHIFT_DAYS_HIGH));
      const paybackFast = yearlyHigh > 0 ? setupPrice / yearlyHigh : null;
      const paybackSlow = yearlyLow > 0 ? setupPrice / yearlyLow : null;
      const lifeLow = yearlyLow * YEARS * DEGRADATION - setupPrice;
      const lifeHigh = yearlyHigh * YEARS * DEGRADATION - setupPrice;
      const co2 = shiftBase * ((UTIL_LOW + UTIL_HIGH) / 2) * 365 * CO2_FACTOR;
      if (out.panels) out.panels.textContent = panels;
      if (out.daily) out.daily.textContent = daily % 1 === 0 ? daily : daily.toFixed(1);
      if (out.kwhYear) out.kwhYear.textContent = kwhYear.toLocaleString('nl-NL');
      if (out.yearly) out.yearly.textContent = yearlyHigh > 0 ? fmtRange(yearlyLow, yearlyHigh) : '€0';
      if (out.payback) {
        if (paybackFast) {
          const slowTxt = (!paybackSlow || paybackSlow > 25) ? '25+' : fmtYears(paybackSlow);
          out.payback.textContent = fmtYears(paybackFast) + ' tot ' + slowTxt + ' jaar';
        } else {
          out.payback.textContent = 'n.v.t.';
        }
      }
      if (out.lifetime) out.lifetime.textContent = lifeHigh > 0 ? fmtRange(Math.max(0, lifeLow), lifeHigh) : 'n.v.t.';
      if (out.co2) out.co2.textContent = Math.round(co2) + ' kg';
      if (out.setup) out.setup.textContent = setup + ' voor ' + fmtEur(setupPrice);
      if (out.setupLink) {
        var variantIds = { 6:'53057009254747', 9:'53057009287515', 12:'53057009320283', 15:'53057009353051', 18:'53057009385819' };
        var linkCap = setupCap > 18 ? 18 : setupCap;
        out.setupLink.href = '/products/hyxi-power-halo-ms3000-stapelbare-thuisbatterij-max-18kwh?variant=' + variantIds[linkCap];
      }
    }
    Object.values(inputs).forEach(el => el && el.addEventListener('input', calc));
    calc();
  }

  // ===== FAQ accordion (group close others) =====
  document.querySelectorAll('[data-faq-group]').forEach(group => {
    group.querySelectorAll('details').forEach(item => {
      item.addEventListener('toggle', function() {
        if (item.open) {
          group.querySelectorAll('details').forEach(o => { if (o !== item) o.open = false; });
        }
      });
    });
  });

  // ===== Product gallery (thumb click) =====
  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    const medias = gallery.querySelectorAll('[data-gallery-media]');
    thumbs.forEach(t => t.addEventListener('click', () => {
      const i = t.dataset.index;
      thumbs.forEach(x => x.classList.toggle('is-active', x === t));
      medias.forEach(m => m.classList.toggle('is-active', m.dataset.index === i));
    }));
  });

  

  // ===== Sticky bottom add-to-cart on mobile product page =====
  if (document.body.classList.contains('template-product')) {
    const stickyAdd = document.querySelector('[data-sticky-add]');
    const mainForm = document.querySelector('[data-configurator]');
    stickyAdd?.addEventListener('click', () => mainForm?.requestSubmit());
  }

})();